import { render, staticRenderFns } from "./RuleList.vue?vue&type=template&id=c89c0142&scoped=true"
import script from "./RuleList.vue?vue&type=script&lang=js"
export * from "./RuleList.vue?vue&type=script&lang=js"
import style0 from "./RuleList.vue?vue&type=style&index=0&id=c89c0142&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c89c0142",
  null
  
)

export default component.exports